import React, { useRef, useState } from 'react'
import classes from './userstable.module.css'
import settingsIcon from '../../assets/icons/menu-dots.svg'
import emptyUsers from '../../assets/images/empty-user.png'
import classNames from 'classnames'
import PurchaseHistoryLoader from '../loaders/PurchaseHistoryLoader'
import { getImageURL } from '../../util/functions'
import avatarImage from '../../assets/images/avatar-dark.svg'
import { useHideOnClickOutside } from '../../hooks/useHideOnClickOutside'
import { Link } from 'react-router-dom'
import Empty from '../Empty/Empty'
import useManageUserActions from '../../hooks/useManageUserActions'

function UsersTable({ users, isFetching }) {
    const [activeUser, setActiveUser] = useState(-1)

    const { toggleUser, deleteUser } = useManageUserActions()

    return (
        <div className={classes.users}>
            {isFetching ? (
                <div>
                    <PurchaseHistoryLoader className={classes.usersLoader} />
                    <PurchaseHistoryLoader className={classes.usersLoader} />
                    <PurchaseHistoryLoader className={classes.usersLoader} />
                </div>
            ) : (
                users.map((user, idx) => (
                    <User
                        key={idx}
                        {...user}
                        index={idx}
                        active={activeUser === idx}
                        toggleActive={index => setActiveUser(index)}
                        deleteUser={() => deleteUser(user.email)}
                        toggleUser={() =>
                            toggleUser(user.email, user.status !== 'Deactivate')
                        }
                        userActive={user.status !== 'Deactivate'}
                    />
                ))
            )}
            {!isFetching && users.length === 0 && (
                <Empty
                    text={'No Users Found'}
                    icon={emptyUsers}
                    className={classes.usersEmpty}
                />
            )}
        </div>
    )
}

const User = ({
    name,
    email,
    enrolled: enrollments,
    index,
    active,
    toggleActive,
    dp,
    deleteUser,
    toggleUser,
    userActive,
}) => {
    const settings = useRef()

    useHideOnClickOutside({
        open: active,
        hide: toggleActive,
        el: settings.current,
    })

    return (
        <Link className={classes.user} to={`/app/business/users/${email}`}>
            <img
                src={dp ? getImageURL(dp) : avatarImage}
                alt="User"
                className={classes.userImage}
            />
            <span className={classes.userText}>
                {name || 'No Name'}
                <span className={classes.userTextEnrollmentsSmall}>
                    {enrollments} Enrollments
                </span>
            </span>
            <span title={email} className={classes.userText}>
                {email}
            </span>
            <span
                className={classNames(
                    classes.userText,
                    classes.userTextEnrollments
                )}
            >
                {enrollments} Enrollments
            </span>
            <button
                className={classes.userSettingsBtn}
                onClick={e => {
                    e.preventDefault()
                    toggleActive(index)
                }}
            >
                <img
                    src={settingsIcon}
                    alt="Settings"
                    className={classes.userSettingsIcon}
                />
            </button>
            <div
                className={classNames(
                    classes.userSettings,
                    active && classes.userSettingsActive
                )}
                ref={settings}
            >
                <button
                    className={classes.userSettingsText}
                    onClick={e => {
                        e.preventDefault()
                        toggleActive(index)
                        toggleUser()
                    }}
                >
                    {userActive ? 'Deactivate' : 'Activate'} user
                </button>
                <button
                    className={classes.userSettingsText}
                    onClick={e => {
                        e.preventDefault()
                        toggleActive(index)
                        deleteUser()
                    }}
                >
                    Delete user
                </button>
            </div>
        </Link>
    )
}

export default UsersTable
